// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"transitionDefault_paragraph__131KP","highlight":"transitionDefault_highlight__1AI2z","btn":"transitionDefault_btn__Igk1N"};